export default function (contentArray: any[]) {
  const validate = (images) => {
    const createObject = (image) => {
      if (image?.fields && Object.keys(image?.fields).length && image?.fields.file) {
        return image;
      }

      image.fields = {
        file: {
          url: '',
          details: {
            image: {},
          },
        },
        title: '',
      };

      return image;
    };

    if (Array.isArray(images)) {
      return images.map(createObject);
    }

    return createObject(images);
  };

  contentArray.forEach((block) => {
    const fields = block?.fields || block;
    const images = fields?.image || fields?.images;
    images && validate(images);

    if (fields?.items && Array.isArray(fields?.items)) {
      fields?.items.map((subItem) => {
        subItem = subItem?.fields || subItem;

        if (subItem?.image?.fields) {
          validate(subItem.image);
        }

        return subItem;
      });
    }
  });

  return contentArray;
}
